import React from 'react';

import Select from '~/modules/shared/components/Select';

import styles from './assets/styles/styles.module.scss';

import AGE_DATA, { COUNT_INTRODUCTION_TEXT } from '~/constants/read_const';

class TestDescription extends React.Component {  
  render() {
    const {
      testCaption,
      testIntroductionPart1,
      testIntroductionPart2,
      nameLabel,
      namePlaceholder,
      ageLabel,
    } = COUNT_INTRODUCTION_TEXT;

    const {
      onNameChangeHandler,
      onAgeChangeHandler,
      ageValue
    } = this.props;

    return (
      <div className={styles.description}>
        <div className={styles.test}>
          <h3 className={styles.caption}>
            {testCaption}
          </h3>
          <p className={styles.text}>
            {testIntroductionPart1}
            <span className={styles['inner-text']}>
              {testIntroductionPart2}
            </span>
          </p>
          <div className={styles['data-selection']}>
            <div className={styles['name-selection']}>
              <span className={styles['name-text']}>{nameLabel}</span>
              <input className={styles['name-input']} placeholder={namePlaceholder} onChange={onNameChangeHandler} />
            </div>
            <div className={styles['age-selection']}>
              <span className={styles['age-text']}>{ageLabel}</span>
              <Select
                onAgeChangeHandler={onAgeChangeHandler}
                ageValue={ageValue}
                ageData={AGE_DATA}
              />
            </div>
          </div>
        </div>
        <div className={styles['white-circle-wrapper']}>
          <div className={styles['white-circle']} />
        </div>
        <div className={styles['fox-image-wrapper']}>
          <div className={styles['fox-image']} />
        </div>
      </div>
    );
  }
}

export default TestDescription;
